// extracted by mini-css-extract-plugin
module.exports = {"account":"Account_account_3vhFn","account__title":"Account_account__title_1nynL","account__photo":"Account_account__photo_1KrWQ","account__badge":"Account_account__badge_2gtmk"};